export default {
  gql: {
    GET_CREDIT_CARD: `
      query($id: String!) {
        getCreditCard(id: $id) {
          name
          type
          brand
          token
          number
          dueDate
          country
        }
      }
    `,
    GET_CREDIT_CARDS: `
      query($accountId: String) {
        getAccountCreditCards(accountId: $accountId) {
          id
          name
          type
          brand
          token
          number
          dueDate
          country
        }
      }
    `,
    SET_CREDIT_CARD: `
      mutation(
        $id: String!
        $name: String
        $type: String
        $brand: String
        $token: String!
        $number: String!
        $country: String
        $dueDate: String!
        $accountId: String
      ) {
        setAccountCreditCard(
          id: $id
          name: $name
          type: $type
          brand: $brand
          token: $token
          number: $number
          dueDate: $dueDate
          country: $country
          accountId: $accountId
        ) {
          id
          name
          type
          brand
          token
          number
          dueDate
          country
        }
      }
    `,
  },
};
